import { render, staticRenderFns } from "./AdditionalOffers.vue?vue&type=template&id=3a914966"
import script from "./AdditionalOffers.vue?vue&type=script&lang=js"
export * from "./AdditionalOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports